import parse from 'html-react-parser';
import Link from 'next/link';
import React from 'react';
import {
  InvisibleAnchor,
  NoUnderlineAnchor,
} from '../../shared-styled/typography/Anchors';
import titleToSlug from '../../utils/titleToSlug';
import UniversalLink from '../UniversalLink/UniversalLink';
import {
  ContentBlock,
  ContentImage,
  ContentTitle,
} from './WhatsNewContentBlock.styled';

const domain = process.env.NEXT_PUBLIC_HOST_ENV
  ? `https://${process.env.NEXT_PUBLIC_HOST_ENV}`
  : 'https://dev.mp.quintagroup.com';

const WhatsNewContentBlock = ({ title, description, img, url }) => (
  <ContentBlock>
    <InvisibleAnchor id={titleToSlug(title)} />
    {img && <ContentImage src={domain + img.path} alt={img.title} />}
    {url ? (
      <UniversalLink href={url} passHref>
        <NoUnderlineAnchor>
          <ContentTitle $isLink={true}>{title}</ContentTitle>
        </NoUnderlineAnchor>
      </UniversalLink>
    ) : (
      <ContentTitle $isLink={false}>{title}</ContentTitle>
    )}
    {parse(description || '')}
  </ContentBlock>
);

export default WhatsNewContentBlock;
